module.exports = __webpack_public_path__ + "static/media/iconTarget.e1288040.svg";